const initialState = {};

export const result = (state = initialState, action) => {
  switch (action.type) {
    case 'ADDUSER':
      return action.data;
    case 'ADDANSW':
      return { ...state, ...action.data };
    case 'SUBANSW':
      return {
        ...state,
        [action.data.menu]: {
          ...state[action.data.menu],
          ...action.data.answ,
          type: 'menu',
        },
      };
    default:
      return state;
  }
};
